import ClickItUserShow from "./clickItUserShow";
import ClickItUserList from "./clickItUserList";
import ClickItUserEdit from "./clickItUserEdit";
import ClickItUserCreate from "./clickItUserCreate";

export default {
  create: ClickItUserCreate,
  show: ClickItUserShow,
  list: ClickItUserList,
  edit: ClickItUserEdit,
};
